import { Component, inject, input, output, signal } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { DialogService } from '@services/index';
import { ProductAutocompleteModel } from '../../products/products.model';
import { AmountVisibilityComponent } from '@magis-ui/magis-ui';

@Component({
  selector: 'product-card',
  imports: [AmountVisibilityComponent, DecimalPipe],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss',
})
export class ProductCardComponent {
  private dialogService = inject(DialogService);

  readonly product = input.required<ProductAutocompleteModel>();
  readonly type = input<'row' | 'column'>('column');
  readonly action = input<'merchant-payment' | 'output'>('merchant-payment');
  readonly disabledFavoriteAction = input(false);
  readonly payWith = input<'account' | 'ticketing'>('account');
  readonly selectedProductEvent = output<ProductAutocompleteModel>();

  isLoading = signal(false);

  // makeFavoriteProducts(favorite: ProductAutocompleteModel, event: Event) {
  //   this.isLoading.set(true);
  //   event.stopPropagation();
  //   let body!: { product: string; product_action: string };
  //   if (!favorite.is_favorite_product) {
  //     body = {
  //       product: favorite.id.toString(),
  //       product_action: 'make_favorite',
  //     };
  //   } else if (favorite.is_favorite_product) {
  //     body = {
  //       product: favorite.id.toString(),
  //       product_action: 'revoke_favorite',
  //     };
  //   }
  //   this.merchantService
  //     .makeFavoriteProduct(body)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe({
  //       next: response => {
  //         if (response.object.success) {
  //           if (!favorite.is_favorite_product) {
  //             this.product().is_favorite_product = true;
  //             this.variableService.REFRESH_FAVORITE_PRODUCTS.set(true);
  //           } else {
  //             this.product().is_favorite_product = false;
  //             this.variableService.REFRESH_FAVORITE_PRODUCTS.set(true);
  //           }
  //         }
  //         this.isLoading.set(false);
  //       },
  //       error: () => {
  //         this.isLoading.set(false);
  //       },
  //     });
  // }

  selectProduct() {
    const action = this.action();
    if (action === 'merchant-payment') {
      this.dialogService.openMerchantPaymentDialog({
        type: 'product',
        product: this.product(),
        payWith: this.payWith(),
      });
    } else if (action === 'output') {
      this.selectedProductEvent.emit(this.product());
    }
  }
}
